import template from './organizationGroupsAndBranchesAdd.template.html';

export default {
  bindings: {
    groupsAndBranches: '=',
    accounts: '=',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $mdDialog,
      $mdMedia,
      $filter,
      $timeout,
      $rootScope,
      eventService,
      organizationService,
      uiService,
      Organization,
      INSTANCE
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.CurrentOrganization = null;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.CurrentOrganization = $rootScope.CurrentOrganization;

        ctrl.destroyWatch = eventService.onGroupsAndBranchesAdd(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                groupsAndBranches: ctrl.groupsAndBranches,
                accounts: ctrl.accounts,
                organization: Organization.blank()
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (organization) {
              uiService.toast({
                text: {
                  p1: 'Organization ' + organization.getName(),
                  p2: 'is being created',
                  p3: 'please wait'
                },
                progress: true,
                warn: true
              });
              organizationService.cloneOrganization(organization).then(function (data) {
                if (data.status) {
                  organization.id = data.id;
                  ctrl.onFinished({ organizationGaB: organization });
                  uiService.toast({
                    text: {
                      p1: 'Organization',
                      p2: organization.getName(),
                      p3: 'has been added'
                    }
                  });
                }
              });
            });

          function dialogController(
            $scope,
            $mdDialog,
            $rootScope,
            INSTANCE,
            groupsAndBranches,
            accounts,
            organization
          ) {
            this.INSTANCE = INSTANCE;
            this.IsEnterprise = $rootScope.IsEnterprise;
            this.availableGroups = _.filter(groupsAndBranches, function (org) {
              return org.isGroup();
            });
            this.organization = angular.copy(organization);
            this.organization.idManagers = [];
            this.organization.idAdministrators = [];
            this.isGroup = !this.availableGroups || !this.availableGroups.length;
            var self = this;
            this.chips = accounts.map(function (account, index) {
              return {
                id: account.id,
                name: account.getName(),
                email: account.user.eMail,
                image: account.user.avatar
              };
            });
            this.chipsAssigned = $filter('filter')(this.chips, function (c) {
              return self.organization.idManagers.indexOf(c.id) > -1;
            });
            this.chipsFilter = function (query) {
              return query
                ? $filter('filter')(this.chips, function (c) {
                    return c.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
                  })
                : [];
            };
            this.confirm = function () {
              this.organization.idRoot = ctrl.CurrentOrganization.id;
              this.organization.idManagers = _.map(self.chipsAssigned, 'id');
              if (
                this.organization.organization.name !== '' &&
                ((this.isGroup && this.organization.isGroup()) ||
                  (!this.isGroup && this.organization.isBranch()))
              ) {
                $mdDialog.hide(this.organization);
              } else {
                uiService.toast({
                  text: {
                    p1: this.isGroup ? 'Group' : 'Branch',
                    p2: this.isGroup ? 'name' : 'name and parent group',
                    p3: this.isGroup ? 'is required' : 'are required'
                  },
                  warn: true
                });
              }
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.groupsAndBranches && changes.groupsAndBranches.currentValue) {
          ctrl.initialize();
        }
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
